/* ==========================================================================
   PURA — correzioni JS del negozio
   Caricato da layout/theme.liquid dopo gli script del tema.

   ⚠️ layout/theme.liquid e' un file del tema: dopo un aggiornamento Xotiny
   verificare che la riga che carica questo file sia ancora presente.
   ========================================================================== */

/* Barra "spedizione gratuita" del carrello.
   Il formattatore JS del tema perde lo zero finale sull'importo mancante:
   scriveva "Spendi ancora €16,1" invece di "€16,10". I prezzi generati da
   Liquid (filtro `money`) sono corretti — il problema riguarda solo questo
   importo, che il tema calcola lato client.
   Qui si normalizzano gli importi con una sola cifra decimale. */
(function () {
  var SEL = '.xo-cart-free-shipping__text';

  function normalizza(el) {
    if (!el) return;
    var testo = el.innerHTML;
    // €16,1 -> €16,10   (solo se c'e' esattamente UNA cifra dopo la virgola)
    var corretto = testo.replace(/(\d+),(\d)(?!\d)/g, '$1,$20');
    if (corretto !== testo) el.innerHTML = corretto;
  }

  function avvia() {
    document.querySelectorAll(SEL).forEach(function (el) {
      normalizza(el);
      new MutationObserver(function () {
        normalizza(el);
      }).observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }
})();
